// The tuning dashboard.
//
// A reading page like `RulesPage`, and for the same reason: this is something
// somebody sits with while a search runs for two days, so it is a screen rather
// than an overlay on a board it has nothing to do with.
//
// Two halves, and they answer different questions. **Progress** is per profile
// and never pooled — a profile is a fitness function, not a competitor, so ten
// champions are ten numbers on ten scales and one shared axis would invite a
// comparison that is not available. **The gallery** is what the numbers cannot
// say: a fitness of 8318 is not an argument anybody can check, and a picture of
// the board it won on is.
//
// **The page itself is `src/client/ai/ui/tuner/`**, one file per part — the dashboard,
// a profile's chart, the decomposition, the game card, the board panel, the
// series switches, the cross round. This file is the export and the door.

import type { AdminPage } from "./AdminNav";
import { Dashboard } from "./tuner/Dashboard";
import { TunerGated } from "./TunerGate";

/**
 * The dashboard, behind its own password.
 *
 * **A separate gate from the deployment's**, because it is a different
 * audience: a playtester holding the game's password has no business reading
 * how the opponent is being trained. And **the gate here is only the visible
 * half** — the server refuses `/api/tuner` and the feed socket without the
 * same cookie, so this cannot be got round by skipping the page.
 */
export function TunerPage({
  onClose,
  onGo
}: {
  onClose: () => void;
  onGo: (page: AdminPage) => void;
}): React.ReactElement | null {
  return (
    <TunerGated
      title="Tuning"
      blurb="How the opponent is being trained, and the games it has been winning."
    >
      <Dashboard onClose={onClose} onGo={onGo} />
    </TunerGated>
  );
}
